export default "__VITE_ASSET__C_uB8Wkb__"